// Main layout component

import { useState, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { MobileHeader } from './MobileHeader';
import { ProgressBar } from './ProgressBar';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();

  // Utilities page needs full width for plan cards
  const isFullWidth = location.pathname === '/utilities';

  return (
    <>
      <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
      <MobileHeader onMenuClick={() => setIsSidebarOpen(true)} />

      <div className={`main-content ${isFullWidth ? 'main-content--full' : ''}`}>
        <ProgressBar />
        <div className="main">{children}</div>
      </div>
    </>
  );
}
